/** Billing period (months) that locks the period toggle when user already has it. */
export const PERIOD_CHANGE_LOCK_PERIOD = 12;

/** Known billing periods used for label maps (not an allowlist for UI). */
export const KNOWN_PERIODS = {
  MONTHLY: 1,
  QUARTERLY: 3,
  YEARLY: 12
};
